module.exports = __webpack_public_path__ + "media/weilai.ca00a7c5.mp3";